export default __webpack_public_path__ + "static/media/uptempo.618ba3f6.jpg";